export function objectFromUrlParams(params: string): { [key: string]: string } {
  const obj: { [key: string]: string } = {};

  const parts = params.split('&');

  parts.forEach((part: string) => {
    // eslint-disable-next-line prefer-destructuring
    const key = part.split('=')[0];
    // eslint-disable-next-line prefer-destructuring
    const value = part.split('=')[1];

    obj[key] = value;
  });

  return obj;
}
